import React, { useEffect, useState } from 'react'

import { notesData } from '../../data'

import { NotesAccordion, NotesAccordionItem } from './components/NotesAccordion'
import { useQuery } from 'react-query'
import { getNotes } from './apiCalls'
import Modal from '../../components/UI/UIModal'
import { Icon } from '../../components/Icon'
import UITextArea from '../../components/UI/UITextArea'
import UIButton from '../../components/UI/UIButton'
import DeleteModal from './components/DeleteModal'
import { deleteScrNote, updateScrNote } from '../../api/admin/scr'
import { createUser, ErrorResponse } from '../../utils/types'
import { toast } from 'react-toastify'
import UITextInput from '../../components/UI/UITextInput'
interface NotesProps {
  setIsOpenEditNotesModal: React.Dispatch<React.SetStateAction<boolean>>
  setIsOpenDeleteNotesModal?: React.Dispatch<React.SetStateAction<boolean>>
  recordId: string
  schoolData: string
}

const Notes: React.FC<NotesProps> = ({ recordId, schoolData }) => {
  const [activeIndex, setActiveIndex] = useState<number | null>(null)
  const [isOpenMenu, setIsOpenMenu] = useState<boolean[]>(
    new Array(notesData?.length || 0).fill(false)
  )
  const [isOpenAddNotesModal, setIsOpenAddNotesModal] = useState<boolean>(false)
  const [isOpenDeleteModal, setIsOpenDeleteModal] = useState<boolean>(false)
  const [isEdit, setIsEdit] = useState(false)
  const [notesDetail, setNotesDetail] = useState<string>('')
  const [notesTitle, setNotesTitle] = useState<string>('')

  const [noteId, setNoteId] = useState('')

  const handleItemClick = (index: number) => {
    setActiveIndex(activeIndex === index ? null : index) // Toggle the active state
  }

  const handleToggleMenu = (rowIndex: number) => {
    const updatedMenuState = isOpenMenu.map((isOpen, index) =>
      index === rowIndex ? !isOpen : false
    )
    setIsOpenMenu(updatedMenuState)
  }

  const notes = useQuery('Noters', () => getNotes(recordId, schoolData))

  const removeNote = async (): Promise<void> => {
    try {
      const response = (await deleteScrNote({
        id: recordId,
        noteId: noteId,
        schoolId: schoolData,
      })) as {
        status?: string
        data: createUser
      }
      if (response?.status == 'successful') {
        notes.refetch()
        setIsOpenDeleteModal(false)
        toast.success('Note Deleted', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }
  const updateNote = async (): Promise<void> => {
    try {
      const response = (await updateScrNote(
        notesTitle,
        notesDetail,
        recordId,
        noteId,
        schoolData
      )) as {
        status?: string
        data: createUser
      }
      if (response?.status == 'successful') {
        notes.refetch()
        setIsOpenAddNotesModal(false)
        toast.success('User Updated', {
          position: 'top-right',
        })
      } else {
        toast.error('Network Error.', {
          position: 'top-right',
        })
      }
    } catch (error) {
      const errors = error as ErrorResponse
      if (errors.response && errors.response.data) {
        const errorMessage = errors.response.data.message || 'An error occurred'
        toast.error(errorMessage, {
          position: 'top-right',
        })
      } else {
        toast.error('An unexpected error occurred', {
          position: 'top-right',
        })
      }
    }
  }

  useEffect(() => {
    notes.refetch()
  }, [notes.data])

  return (
    <div
      style={{
        height: 'calc(100vh - 100px)',
        overflow: 'auto',
        // scrollbarWidth: 'none',
      }}
    >
      <div className="flex flex-col my-8 gap-2">
        {/* content container */}
        <div className={'w-[100%]'}>
          <NotesAccordion>
            {notes?.data?.map((i, index: number) => (
              <NotesAccordionItem
                key={index}
                isActive={index == activeIndex}
                onClick={() => {
                  handleItemClick(index)
                }}
                title={i?.createdAt?.substring(0, 16)}
                title2={i?.title}
                menuItems={[
                  {
                    label: 'Edit',
                    onClick: () => {
                      setIsEdit(true)
                      setIsOpenAddNotesModal(true)
                      setNoteId(i.id)
                      setNotesDetail(i.detail)
                      setNotesTitle(i.title)
                    },
                    icon: 'IconEdit',
                    iconColor: '#02698C',
                  },
                  {
                    label: 'Remove',
                    onClick: () => {
                      setIsOpenDeleteModal(true)
                      setNoteId(i.id)
                    },
                    icon: 'IconTrash',
                    iconColor: '#FF6666',
                    textColor: 'text-textError',
                  },
                ]}
                isOpenMenu={isOpenMenu[index]}
                onClickMenu={(e) => {
                  e.stopPropagation()
                  handleToggleMenu(index)
                }}
                setIsOpenMenu={setIsOpenMenu}
                isOpenMenusArray={isOpenMenu}
              >
                <div className="overflow-hidden rounded-[16px] w-full p-2">
                  <div className="overflow-hidden rounded-[16px] w-full my-[30px]">
                    <table className="rounded-[16px] overflow-hidden border w-full border-white">
                      <tbody>
                        <tr key={index} className="bg-gray1">
                          {/* Example row */}
                          <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                            Details
                          </td>
                          <td className="px-4 text-sm font-semibold leading-6 text-text1 text-justify py-2 border border-white">
                            {i.detail}
                          </td>
                        </tr>
                        <tr key={index} className="bg-gray1">
                          {/* Example row */}
                          <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                            Created at
                          </td>
                          <td className="px-4 text-sm font-semibold leading-6 text-text1 h-[48px] py-2 border border-white">
                            {i.createdAt?.substring(0, 16)}
                          </td>
                        </tr>
                        <tr key={index} className="bg-gray1">
                          {/* Example row */}
                          <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                            Created By
                          </td>
                          <td className="px-4 text-sm font-semibold leading-6 text-text1 h-[48px] py-2 border border-white">
                            {i.createdByName}
                          </td>
                        </tr>
                        <tr key={index} className="bg-gray1">
                          {/* Example row */}
                          <td className="bg-gray2 px-4  text-text1 font-semibold text-[14px] w-[30%] h-[48px] py-2 border border-white">
                            Updated By
                          </td>
                          <td className="px-4 text-sm font-semibold leading-6 text-text1 h-[48px] py-2 border border-white">
                            {i.updatedByName}
                          </td>
                        </tr>

                        {/* Add more rows as needed */}
                      </tbody>
                    </table>
                  </div>
                </div>
              </NotesAccordionItem>
            ))}
          </NotesAccordion>
        </div>
      </div>
      <Modal
        customStyle={{
          borderRadius: 16,
          padding: '20px 16px',
          width: '480px',
        }}
        isOpen={isOpenAddNotesModal}
        onClose={() => {
          setIsOpenAddNotesModal(false)
          setIsEdit(false)
        }}
      >
        <div
          className={
            'max-h-[80vh] min-h-[45vh] items-center  p-4 flex flex-col gap-4'
          }
        >
          <div
            onClick={() => {
              setIsOpenAddNotesModal(false)
              setIsEdit(false)
            }}
            className="flex w-[100%] justify-end cursor-pointer"
          >
            <Icon name={'IconCross'} stroke="#02698C" height={16} width={16} />
          </div>
          <div className="flex items-center w-[100%] justify-center">
            <Icon
              name={'IconStickerSquare'}
              stroke={'#02698C'}
              strokeWidth={0.5}
              height={56}
              width={56}
            />
          </div>
          <div className="flex flex-col gap-2 items-center w-[100%] justify-center">
            <h1 className={'text-text2 text-lg font-bold leading-6'}>
              {isEdit ? 'Edit Note' : 'Add Note'}
            </h1>
            <p className={'text-sm leading-5 text-text1 font-normal'}>
              {' Please enter the details about this note'}
            </p>
          </div>
          <div className="w-full flex-col flex gap-4 mt-3">
            <div>
              <UITextInput
                iconName=""
                label="Title*"
                placeholder="title"
                onChange={(e) => {
                  setNotesTitle(e.target.value)
                }}
                value={notesTitle}
              />
            </div>
            <div>
              <UITextArea
                label="Note Details*"
                placeholder="Write Note Details here"
                rows={7}
                onChange={(e) => {
                  setNotesDetail(e.target.value)
                }}
                value={notesDetail}
              />
            </div>
          </div>
          <div className="w-full mt-4">
            <UIButton
              // loading={addNotesLoading}
              onClick={updateNote}
              label={isEdit ? 'Update' : 'Add'}
            />
          </div>
        </div>
      </Modal>

      <DeleteModal
        isOpen={isOpenDeleteModal}
        onClose={() => {
          setIsOpenDeleteModal(false)
        }}
        title="Delete Note"
        description="Are you sure you want to delete this Note?"
        onConfirm={removeNote}
        icon="IconAlertTriangle"
      />
    </div>
  )
}

export default Notes
